import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
import Modal from './Modal';
import EcoImg from 'eco-design/base/eco-img';
import gtm from 'eco-design-reliance/gtm';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const A: React.FC = () => {
    const { t } = useLang('shp3');
    const [enter, setEnter] = useState({
        desc: false,
        btn: false,
    });
    const [modalOpen, setModalOpen] = useState(false);
    const webpOrJpg = useWebpOrJpg('#shp3-B');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneHArr: any[] = [];
            ['desc', 'btn'].forEach((item: string) => {
                const dom: HTMLElement | null = document.querySelector(`.shp3-B .${item}-ani`);
                if (dom) {
                    sceneHArr.push(
                        AniContainer.create({
                            triggerElement: `#shp3-B .${item}-ani`,
                            triggerHook: 1,
                            offset: window.innerWidth > 768 ? dom?.offsetHeight + (item === 'desc' ? 180 : 60) : dom?.offsetHeight,
                            duration: window.innerHeight * 1.2,
                            onEnter: () =>
                                setEnter((prev) => ({
                                    ...prev,
                                    [item]: true,
                                })),
                            onLeave: () =>
                                setEnter((prev) => ({
                                    ...prev,
                                    [item]: false,
                                })),
                        }),
                    );
                }
            });
            return () => {
                sceneHArr.forEach((item) => {
                    item.destroy();
                });
            };
        }
    }, []);
    const handleOpenModal = () => {
        setModalOpen(true);
    };

    return (
        <section className={`${css.section} shp3-B GtmModuleData-section`} id="shp3-B" data-section-id={'shp3-B'} data-section-title={t('B_title')}>
            <div className="eco-img">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1760091175543/pc_%E7%B3%BB%E7%BB%9F%E4%BB%8B%E7%BB%8D.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1760091186485/pc_%E7%B3%BB%E7%BB%9F%E4%BB%8B%E7%BB%8D.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1760091175418/m_%E7%B3%BB%E7%BB%9F%E4%BB%8B%E7%BB%8D.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1760091186221/m_%E7%B3%BB%E7%BB%9F%E4%BB%8B%E7%BB%8D.webp',
                    )}
                />
            </div>
            <div className={`info`}>
                <div className="desc">
                    <p className={`desc-ani ani-1 ${enter.desc ? 'enter' : ''}`}>{t('B_desc')}</p>
                </div>
            </div>
            <div
                className="btn-ani GtmModuleData-btn-text"
                onClick={() => {
                    setModalOpen(true);
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'product_details',
                        tab: t('B_title'),
                        button_name: t('B_btn'),
                        __btn_id1: `shp3-B .btn`,
                        __btn_id2: t('B_btn'),
                        __btn_type: 'text',
                    });
                }}
            >
                <span className={`btn GtmModuleData-btn-text${enter.btn ? ' enter' : ''}`} onClick={handleOpenModal}>
                    {t('B_btn')}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 24" fill="none">
                        <path
                            d="M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z"
                            fill="#3F68E0"
                        />
                        <path d="M8.125 12H16.875" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12.5 7.625V16.375" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
            </div>
            {modalOpen && <Modal callback={() => setModalOpen(false)}></Modal>}
        </section>
    );
};

export default A;
